import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20photography%20background%20with%20warm%20golden%20and%20terracotta%20gradients%2C%20soft%20bokeh%20light%20circles%2C%20elegant%20camera%20lens%20reflections%2C%20minimalist%20composition%20with%20geometric%20light%20patterns%2C%20modern%20aesthetic%20photography%20studio%20atmosphere%2C%20clean%20artistic%20style%20with%20depth%20of%20field%20effect%2C%20warm%20cream%20and%20amber%20tones&width=1800&height=900&seq=hero-selfie-background&orientation=landscape"
        alt="国产自拍完全指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-primary-200 text-sm md:text-base font-label tracking-widest uppercase mb-4">
            Selfie Mastery Guide
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            国产自拍完全指南
            <span className="block text-lg md:text-2xl font-normal text-background-200 mt-3 font-body">
              拍出高质感大片，从入门到精通
            </span>
          </h1>
          <p className="text-background-200/90 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            从手机选购、构图布光到后期修图，手把手教你用国产设备拍出专业级自拍效果。掌握核心技巧，让每一张照片都成为精彩瞬间。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/goutu-jiqiao"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始学习构图技巧
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/shebei-xuangou"
              className="px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors border border-background-50/30 whitespace-nowrap cursor-pointer"
            >
              查看设备推荐
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}